///////////////////////////////////////////////////////////////////////////////////
// STYLES, in production, these will be written to <script> tags
///////////////////////////////////////////////////////////////////////////////////
import './loading.css';
import styles from './index.scss';

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// GLOBAL VARIABLES & STRUCTURES
///////////////////////////////////////////////////////////////////////////////////////////////////////////
// global config
const CONFIG = {};
const DATA = {};

// Style definitions

// 10 county style
CONFIG.ten_county_style = { weight: 2, color: '#000', opacity: 0.9, fill: false, fillOpacity: 0 };
// style for highlighting districts on hover and click
CONFIG.district_default_style  = { weight: 2, color: '#000000', opacity: 0.3, fill: '#fff', fillOpacity: 0 };
CONFIG.district_hover_style    = { weight: 3, color: '#eb724b', opacity: 0.8, fill: '#fff', fillOpacity: 0 };
CONFIG.district_selected_style = { weight: 4, color: '#eb4e1d', opacity: 1, fill: '#fff', fillOpacity: 0 };
// an "invisible" style, as we don't want counties or other geographies to show except on hover or click
// CONFIG.no_style = { opacity: 0, fill: '#fff', fillOpacity: 0 };

// the district types, and the field in geojson that identifies them
CONFIG.district_types = {
  'counties': {field: 'name'},
  'assembly-new': {field: 'DISTRICT'},
  'assembly-current': {field: 'District'},
  'senate-new': {field: 'DISTRICT'},
  'senate-current': {field: 'District'},
  'native-lands': {field: 'Name'},
}

// String formatting functions
CONFIG.format = {
  'usd': function(n) {return '$' + parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})},
  'usd_billions_millions_thousands': function(n) { 
    // differential formatting if gt 1B or lt 1M, lt 1M, or lt 100000:
    let z;
    if (n < 1000000) {
      // less than 1 million
      z = n;
      return '$' + z.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    } else if (n >= 1000000 && n < 1000000000 ) {
      // gt 1 million, less than 1 billion
      z = n / 1000000; // divide by 1 million
      // let digits = z % 2 === 0 ? 0 : 1;
      return '$' + z.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + ' million';
    } else if (n >= 1000000000 ) {
      // gt 1 billion
      z = n / 10000000; // divide by 1 billion
      return '$' + z.toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + ' billion';
    }
   },
  'number': function(n) {
    if (isNaN(n) || n === null) {
      return '0';
    } else {
      return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    }
  },
  'float': function(n) {return parseFloat(n).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})},
  'none': function(n) {return n},
}

// Lookups for sums
CONFIG.summaries = {
  jobs: {format: 'number'},
  served: {format: 'number'},
  funding: {format: 'usd_billions_millions_thousands'},
}

// track the initial load of the application
CONFIG.first_load = false;

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// INITIALIZATION: these functions are called when the page is ready,
///////////////////////////////////////////////////////////////////////////////////////////////////////////
$(document).ready(function () {
  // data initialization first, then the remaining init steps
  Promise.all([
      initData('./static/data/data.csv'), 
      initData('./static/data/ten_county.json'),
      initData('./static/data/counties.json'),
      initData('./static/data/assembly_new.json'),
      initData('./static/data/assembly_current.json'),
      initData('./static/data/senate_new.json'),
      initData('./static/data/senate_current.json'),
      initData('./static/data/native-lands.json'),
    ])
    .then(function(data) {
      initDataFormat(data)    // get data ready for use
      initMap();              // regular leaflet map setup
      initMapLayers();        // init some map layers and map feature styles
      initControls();         // init the district selects
      initButtons();          // misc. button inits and delegated event handlers
      initModal();            // init the modal that shows a cards details when clicked
      initState();            // init app state. This is the app "entry point"

// console.log(DATA);
// console.log(CONFIG);

    }); // end Promise.then()


});


///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// FUNCTIONS CALLED ON DOC READY
///////////////////////////////////////////////////////////////////////////////////////////////////////////

// Basic data init, returns a promise
function initData(url) {
  // wrap this in a promise, so we know we have it before continuing on to remaining initialize steps
  return new Promise(function(resolve, reject) {
    $.get(url, function(data) {
      resolve(data);
    });
  });
}

// Data formatting routines, to get the static, raw data files into the form we need it in
function initDataFormat(data) {
  // format the project data from CSV
  var rawjson = Papa.parse(data[0], {
    header: true,
    skipEmptyLines: 'greedy',
    // trim whitespace from each cell
    transform: function(r) {return r.trim()}
  });
  rawjson.data.forEach(function(row) {
    // split and map the political districts and counties to raw values matching the GeoJSON
    // not needed for native-lands as the names in the data already match the GeoJSON
    row['assembly-current'] = row['assembly-current'].split(';').map(function(d) { return d.replace('AD ', '') });
    row['assembly-new'] = row['assembly-new'].split(';').map(function(d) { return d.replace('AD ', '') });
    row['senate-current'] = row['senate-current'].split(';').map(function(d) { return d.replace('SD ', '') });
    row['senate-new'] = row['senate-new'].split(';').map(function(d) { return d.replace('SD ', '') });
    row.counties  = row.counties.split(';');
  
    // turn the following strings and ranges into raw integers
    // so we can do math with them
    switch (row['peopleserved']) {
      case '<50':
        row['served_number'] = 50;
        break;
      case '51-100':
        row['served_number'] = 100;
        break;
      case '101-1000':
        row['served_number'] = 1000;
        break;
      case '1001-5000':
        row['served_number'] = 5000;
        break;
      case '5001+':
        row['served_number'] = 10000;
        break;
      default:
        row['served_number'] = 0;
        break; 
    }

    switch (row['peopleemployed']) {
      case '<20':
        row['employed_number'] = 20;
        break;
      case '21-50':
        row['employed_number'] = 50;
        break;
      case '51-100':
        row['employed_number'] = 100;
        break;
      case '101-999':
        row['employed_number'] = 1000;
        break;
      case '1000+':
        row['employed_number'] = 5000;
        break;
      default:
        row['employed_number'] = 0;
        break; 
    }

    switch (row['estimatedneed']) {
      case '<$250,000':
        row['funding_number'] = 250000;
        break;
      case '$251k - $500k':
        row['funding_number'] = 500000;
        break;
      case '$501k - $1m':
        row['funding_number'] = 1000000;
        break;
      case '$2m - $10m':
        row['funding_number'] = 10000000;
        break;
      case '$11m+':
        row['funding_number'] = 15000000;
        break;
      default:
        row['funding_number'] = 0;
        break; 
    }
  });
  
  // keep a reference to the raw data
  DATA.projects = rawjson.data;

  // set 10 county outline data equal to the second data object from the initData() Promise()
  DATA.ten_country_data = data[1];

  // keep a reference to the county GeoJSON data
  DATA.counties = data[2];

  // keep a reference to the Assembly (new) GeoJSON data
  DATA.assembly_new = data[3];

  // keep a reference to the Assembly (current) GeoJSON data
  DATA.assembly_current = data[4];

  // keep a reference to the Senate (new) GeoJSON data
  DATA.senate_new = data[5];

  // keep a reference to the Senate (current) GeoJSON data
  DATA.senate_current = data[6];

  // keep a reference to the Indigenous territories GeoJSON data
  DATA.native_lands = data[7];

  // get the initial count of projects by goal/location
  updateProjectGoalCount();
}

function initMap() {
  // basic leaflet map setup
  CONFIG.map = L.map('map', {
    attributionControl: false,
    zoomControl: false, // see initMapLayers()
    minZoom: CONFIG.minzoom, maxZoom: CONFIG.maxzoom,
    scrollWheelZoom: false,
  });

  // - create a map pane for the parkinfo basemap tiles
  CONFIG.map.createPane('parkinfo-basemap');
  CONFIG.map.getPane('parkinfo-basemap').style.zIndex = 200;

  // - create a map pane for the 10-county boundary 
  CONFIG.map.createPane('ten-county-outline');
  CONFIG.map.getPane('ten-county-outline').style.zIndex = 320;

  // - create a map pane for district interactions
  CONFIG.map.createPane('district-interact');
  CONFIG.map.getPane('district-interact').style.zIndex = 350;

  // - create a map pane for parkinfo labels
  CONFIG.map.createPane('parkinfo-labels');
  CONFIG.map.getPane('parkinfo-labels').style.zIndex = 350;
  CONFIG.map.getPane('parkinfo-labels').style.pointerEvents = 'none';

}

function initMapLayers() {
  // add the parkinfo tiles to the map
  L.mapboxGL({
      accessToken: 'pk.eyJ1IjoiZ3JlZW5pbmZvIiwiYSI6Ik1HUWRtdEkifQ.aWQKcu787DGrDq7LN5r2iA',
      style: 'mapbox://styles/greeninfo/cin0wlnzz001mahm6u4bzabin',
      pane: 'parkinfo-basemap',
  }).addTo(CONFIG.map);

  // // add the parkinfo labels to the map
  // these are broken in MB and there is no replacement atm
  // L.mapboxGL({
  //     accessToken: 'pk.eyJ1IjoiZ3JlZW5pbmZvIiwiYSI6Ik1HUWRtdEkifQ.aWQKcu787DGrDq7LN5r2iA', 
  //     style: 'mapbox://styles/greeninfo/cl0afnnzj000615nzoshv904v',
  //     pane: 'parkinfo-labels',
  // }).addTo(CONFIG.map);

  // add the county outline to the map. This layer is always on, and is not interactive
  const ten_county_layer = L.geoJSON(DATA.ten_country_data, {
    style: CONFIG.ten_county_style,
    interactive: false,
    pane: 'ten-county-outline'
  }).addTo(CONFIG.map);

  // save the bounds of the 10 county outline, and fit the map to it
  CONFIG.homebounds = ten_county_layer.getBounds();
  CONFIG.map.fitBounds(CONFIG.homebounds);
  CONFIG.map.setMaxBounds(CONFIG.homebounds);

  // construct the custom zoom home control and add it to the map
  CONFIG.zoombar = new L.Control.ZoomBar({
    position: 'topright',
    // homeLatLng: [CONFIG.startlat, CONFIG.startlng],
    homeBounds: CONFIG.homebounds,
    homeZoom: CONFIG.startzoom,
  }).addTo(CONFIG.map);

  // District Layers:
  // create the counties layer: not added to the map until selected in the dropdown
  CONFIG.district_types['counties'].layer = L.geoJSON(DATA.counties, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    onEachFeature: function(feature, layer) { registerFeatureEvents('counties', layer) },
  });

  // create the assembly (new) layer: not added to the map until selected in the dropdown
  CONFIG.district_types['assembly-new'].layer = L.geoJSON(DATA.assembly_new, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    onEachFeature: function(feature, layer) { registerFeatureEvents('assembly-new', layer) },
  });

  // create the assembly (current) layer: not added to the map until selected in the dropdown
  CONFIG.district_types['assembly-current'].layer = L.geoJSON(DATA.assembly_current, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    onEachFeature: function(feature, layer) { registerFeatureEvents('assembly-current', layer) },
  });

  // create the senate (new) layer: not added to the map until selected in the dropdown
  CONFIG.district_types['senate-new'].layer = L.geoJSON(DATA.senate_new, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    onEachFeature: function(feature, layer) { registerFeatureEvents('senate-new', layer) },
  });

  // create the senate (current) layer: not added to the map until selected in the dropdown
  CONFIG.district_types['senate-current'].layer = L.geoJSON(DATA.senate_current, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    onEachFeature: function(feature, layer) { registerFeatureEvents('senate-current', layer) },
  });

  // create the Native Lands layer: not added to the map until selected in the dropdown
  // this one is not like the others: multiple overlapping polygons add some complexity
  CONFIG.district_types['native-lands'].layer = L.geoJSON(DATA.native_lands, {
    style: CONFIG.district_default_style,
    pane: 'district-interact',
    // register the same hover events, but skip click events in lieu of the following click event handler
    onEachFeature: function(feature, layer) { registerFeatureEvents('native-lands', layer) },
  }).on('click', function(e) {
      // collect matches for this lat-lng in each of the native-lands layers
      let matches = leafletPip.pointInLayer([e.latlng.lng, e.latlng.lat], CONFIG.district_types['native-lands'].layer, false);
      if (matches.length > 1) {
        // if there is more than one match, create and open a popup with a choice
        var div = $('<div>', {
          html: '<p class="popup-header">This area has more than one value</p>\
          <p class="popup-intro"><i>Select a name below for more information<i></p>'
        });
        matches.forEach(function(layer) {
          // see initButtons for the delegated event handler for these
          var p = $('<p>', {'class': 'popup-name', text: layer.feature.properties['Name']})
          p.attr('data-val', layer.feature.properties['Name']);
          p.appendTo(div);
        });
        // all set, open the popup
        CONFIG.map.openPopup(div.html(),e.latlng);
      } else {
        // we have a single selection
        let name = matches[0].feature.properties['Name'];
        // pretend we selected this from the dropdown
        $('select#native-lands').val(name).trigger('change');
      }

      // Show or hide the "Please select..." alert message
      syncDistrictAlertMessage();
      // update the state params in the address bar
      updateStateParams();
      // final step: update the cards below the map
      updateCards(); 
  });
}

// init state from params, or not
function initState() {
  // check for params, and if found, use them to update the view
  var params = new URLSearchParams(window.location.search);
  // check if the params object has anything in it
  if (params.toString()) {
    // load the app from the params
    applyStateParams();
  } else {
    // no params, just show all the cards
    updateCards();
  }

  // ready!
  $('div#loading').hide();
  CONFIG.first_load = false;
}

function initControls() {
  // when a geography type is selected, 
  // show the associated dropdown, and show the layer on the map
  $('select.district-type-select').on('change', function() {
    // call the primary change function
    districtTypeSelectChange(true);
    // update the state params in the address bar
    updateStateParams();
  });

  // when a location is selected, update the map and cards
  $('select.location-select').on('change', function() {
    let id = this.value;
    let type = $('select.district-type-select').val();
    // sync the map, for all types but bay-area
    if (type != 'bay-area') {
      let field = CONFIG.district_types[type].field;
      CONFIG.district_types[type].layer.eachLayer(function(layer) {
        // first unselect all 
        layer.selected = false; 
        layer.setStyle(CONFIG.district_default_style);
        // then, if we find a match, select it
        if (layer.feature.properties[field] == id) {
          layer.selected = true;
          layer.setStyle(CONFIG.district_selected_style);
          layer.bringToFront();
          CONFIG.map.fitBounds(layer.getBounds());
        }
      });
    }

    // show or hide the "Please select..." alert message
    syncDistrictAlertMessage();

    // Then do the following, but only if we have changed to "default"
    if (id !== 'default') {
      // update the state params in the address bar
      updateStateParams();
      // finally, filter and update the cards below
      updateCards();
    }
  });

  // when a "goal" checkbox is checked/unchecked, update the map and cards
  $('div#goal-checks input[type="checkbox"]').on('change', function() {
    // update the state params in the address bar
    updateStateParams();
    // finally, filter and update the cards below
    updateCards();
  });
}

function initButtons() {
  // delegated click handler for links in popups that allow a user to choose between multiple matching places
  $('div#map').on('click', 'p.popup-name', function() {
    let name = $(this).data().val;
    // a bit of a hack, just pretend we selected this from the dropdown
    $('select#native-lands').val(name).trigger('change');
    CONFIG.map.closePopup();
  });

  // init the BS modal
  CONFIG.modal = new bootstrap.Modal(document.getElementById('project-details-modal'), {});

  // init the behavior of the "clear selection" button
  $('button#clear').on('click', function() {
    // check all the checkboxes
    $('div#goal-checks input[type="checkbox"]').prop('checked', true);
    // then just pretend we selected 'bay-area'
    $('select.district-type-select').val('bay-area').trigger('change');
    // reset the map view to the full extent
    CONFIG.map.fitBounds(CONFIG.homebounds);
  });
}

function initModal() {
  // this app is in an iframe with a iframe scroll hack, so modals needs repositioning to be visible
  // add margin so the modal content is vertically positioned to the element we clicked
  if (window.parent === window) return; // not in an iframe, return early

  const modaldiv = document.querySelector('#project-details-modal');
  const modalcontent = modaldiv.querySelector('div.modal-content');

  modaldiv.addEventListener('shown.bs.modal', function () {
    const $opener = $('#project-details-modal').data('opener');
    let top = $opener ? $opener.offset().top - $opener.height() : 0;

    const modalheight = $(modalcontent).height();
    if (top + modalheight > $(window).height()) {
      top -= 0.5 * modalheight;
    }

    // all set: add the new top margin
    modalcontent.style.marginTop = `${top}px`;
  });
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// NAMED FUNCTIONS 
///////////////////////////////////////////////////////////////////////////////////////////////////////////

function syncDistrictAlertMessage() {
  let parent = $('select.district-type-select').val();
  let child = $('select.location-select:visible').val();

  // hide the "select me" alerts, initially
  $('span.select-alert').hide();
  // If location-select value is 'default', show or hide the correct "Please select..." prompt
  if (child == 'default') {
    // show the "select me" alert for this type
    $(`span#${parent}-alert`).show();
  }
}

// pulling this out from the change event itself so we have additional options
function districtTypeSelectChange(update_selects=true) {
  // get the value of the "parent" select
  let parent_value = $('select.district-type-select').val();

  // always hide this initially, because it's possible to get here from params and end up with two showing
  $('select#counties').hide(); 
  
  // When change comes from the select itself, we want to update the child select
  // if it doesn't (e.g. from params) then do those updates using the provided params for the child
  if (update_selects) {
    // hide all the children selects
    $('select.location-select').hide();
    // weird hack here, since bay-area doesn't have a child, arbitrarily show one to match the design
    if (parent_value == 'bay-area') {
      // show the counties select but disable it
      $('select#counties').val('default').show().attr('disabled', true);
      // reset the map view
      CONFIG.map.fitBounds(CONFIG.homebounds);
    } else {
      // show the child select that we want based on the parents value
      $(`select#${parent_value}`).val('default').show().attr('disabled', false);  
    }
  }

  // always show or hide the "Please select..." alert message
  syncDistrictAlertMessage();

  // remove the current district layers from the map, if there is one
  Object.keys(CONFIG.district_types).forEach(function(key) {
    const layer = CONFIG.district_types[key].layer;
    if (CONFIG.map.hasLayer(layer)) CONFIG.map.removeLayer(layer);
  });

  // add the boundaries to the map for the parent type we selected 
  // except for bay-area, which is already on the map
  if (parent_value != 'bay-area') {
    // first clear any lingering selection
    CONFIG.district_types[parent_value].layer.eachLayer(function(layer) {
      layer.setStyle(CONFIG.district_default_style);
    });
    CONFIG.district_types[parent_value].layer.addTo(CONFIG.map);
  }

  // update cards, but only if the parent selection is 'bay-area'
  if (parent_value == 'bay-area') updateCards();
}

// register feature events as they are being constructed from GeoJSON
function registerFeatureEvents(key, layer) {
  layer.on('mouseover', function() {
    if (!this.selected) this.setStyle(CONFIG.district_hover_style);
  }).on('mouseout', function() {
    if (!this.selected) this.setStyle(CONFIG.district_default_style);
  }).on('click', function() {
    // same click handling routine for all district layers but native-lands
    // for that one, see the on('click') events registered on the entire layer, in initMapLayers() above
    if (key == 'native-lands') return;
    let field = CONFIG.district_types[key].field;
    let id = this.feature.properties[field];
    // if it's already selected, then unselect it
    if (this.selected) {
      this.setStyle(CONFIG.district_default_style);
      this.selected = false;
      $('select.location-select').val('default');
    } else {
      // first unselect all geographies
      CONFIG.district_types[key].layer.eachLayer(function(layer) {
        layer.selected = false; 
        layer.setStyle(CONFIG.district_default_style); 
      });
      // then select this one on the map
      this.selected = true;
      this.setStyle(CONFIG.district_selected_style);
      this.bringToFront();
      CONFIG.map.fitBounds(layer.getBounds());
      // and sync the <select>
      $('select.location-select').val(id);
    }
    // Show or hide the "Please select..." alert message
    syncDistrictAlertMessage();
    // update URL params
    updateStateParams();
    // final step: update the cards below the map 
    updateCards();
  })
}

// function that updates the cards shown below the map
function updateCards() {
  // gather the selected values for place type, place and goals
  let place_type = $('select.district-type-select').val();
  let place = $('select.location-select:visible').val();
  let goals = $.map($('div#goal-checks input[type="checkbox"]:checked'), function(e) { return e.value; });
  let allgoals = $.map($('div#goal-checks input[type="checkbox"]'), function(e) { return e.value; });

  // show the summary message, which will have been hidden, except in the case of 'bay-area'
  $('div#form-summary-message').show();
  if (place == 'default' && place_type != 'bay-area')  {
    $('div#form-summary-message').hide();
  }

  // show or hide the "clear selection" button
  if (place != 'default' && place_type != 'bay-area') {
    $('button#clear').attr('disabled', false);
  } else {
    $('button#clear').attr('disabled', true);
  }

  // A two part filter: 
  // Part 1: Filter for the selected place
  let matching_projects_by_place;
  if (place_type == 'bay-area') {
    // all projects match
    matching_projects_by_place = DATA.projects;
  } else {
    // filter by the selected place
    matching_projects_by_place = DATA.projects.filter(function(project) {
      return (project[place_type].indexOf(place) > -1)
    });
  }

  // Part 2: Filter the matching places by selected goals using array comparison
  let matches = matching_projects_by_place.filter(function(project) {
    return goals.some(function(i) { return project['30x30objectives'].includes(i)});
  });

  // update the "goal" counts, by the goal checkboxes
  updateProjectGoalCount(matches);

  // update the dynamic "form summary message" below the form
  updateFormSummaryMessage(matches);

  // sort matches, alphabetical by project name
  matches = matches.sort(function(a,b) { return a.projecttitle.localeCompare(b.projecttitle)});

  // create the cards, one for each matching project
  let target = $('div#cards div.row').empty();
  matches.forEach(function(match) {
    let col = $('<div>', {
      class: 'col',
    }).appendTo(target);
  
    // a card wrapper
    let outer = $('<a>', {
      class: 'card-outer',
    }).appendTo(col);

    outer.on('click', function(e) { openModal(match, outer) });

    // the card itself
    let card = $('<div>', {
      class: 'card',
    }).appendTo(outer);

    // card body
    let body = $('<div>', {
      class: 'card-body',
    }).appendTo(card);

    // wrapper for goal icons
    let circle_div = $('<div>', {
      class: 'circle-outer',
    }).appendTo(body);

    // goal "circles" or icons
    match['30x30objectives'].split(';').forEach(function(goal) {
      $('<span>', {
        class: `circle ${goal}`,
      }).appendTo(circle_div);
    });

    // project name
    $('<h4>', {
      class: 'card-title',
      text: match.projecttitle,
    }).appendTo(body);

    // organization title
    $('<h5>', {
      class: 'card-org',
      text: match.organization
    }).appendTo(body);

    // intro/body text
    $('<div>', {
      class: 'card-intro',
      text: match.briefdescription,
    }).appendTo(body);

    // add a link for "more" to indicate that clicking the card opens the modal
    $('<a>', {
      class: 'card-link',
      html: '&#43; More info'
    }).appendTo(body);

    // regional pill
    if (match.regional) {
      $('<div>', {
        class: 'card-regional',
        text: 'region wide',
      }).appendTo(circle_div);
    }

  });
}

// clear out selections and restore "defaults"
function resetApp() {
  $('select.district-type-select').val('bay-area').trigger('change');
  updateCards();
}

// update the state params in the address bar to reflect current params and options
function updateStateParams() {
  if (CONFIG.first_load) return;

  // get the current search params
  let params = new URLSearchParams(window.location.search);

  // set a param to track selected district/geography type
  params.delete('geography_type');
  let geography_type = $('select.district-type-select').val();
  params.append('geography_type', geography_type);

  // set a param to track selected district/geography value
  params.delete('geography_value');
  let geography_value = $('select.location-select:visible').val();
  // this one is optional and may not be present
  if (geography_value) params.append('geography_value', geography_value);

  // access checkbox
  params.delete('access');
  if ($('input#access-check').is(':checked')) params.append('access', true);

  // climate checkbox
  params.delete('climate');
  if ($('input#climate-check').is(':checked')) params.append('climate', true);

  // biodiversity checkbox
  params.delete('biodiversity');
  if ($('input#biodiversity-check').is(':checked')) params.append('biodiversity', true);

  // all set! if we have anything, parse the string, make it a query and
  // replace state in our local address bar
  let searchstring = decodeURIComponent(params.toString());
  if (searchstring) {
    var newparams = '?' + searchstring;
    window.history.replaceState(newparams, '', newparams);
  }

  // final step: Let the iframe know the new params
  // so we can get this on the address bar of the parent page
  parent.postMessage(newparams, '*');
}


// if the URL contains URL params, parse them and set the application state
function applyStateParams() {
  // use URLSearchParams to get the params
  let params = new URLSearchParams(window.location.search);

  // first check for params we know about, and respond accordingly
  // Note: this approach implies that any new params added in the future, must be added to this if statement
  if (params.has('access') || params.has('climate') || params.has('biodiversity') || params.has('geography_value')) {

    // update checkboxes based on params
    // if we have any of these params, then clear the checkboxes out, and recheck them based on those that are present
    if (params.has('access') || params.has('climate') || params.has('biodiversity')) {
      $('div#goal-checks input[type="checkbox').prop('checked', false);
    }
    if (params.has('access')) $('input#access-check').prop('checked', true);
    if (params.has('climate')) $('input#climate-check').prop('checked', true);
    if (params.has('biodiversity')) $('input#biodiversity-check').prop('checked', true);

    // check for selected geography type
    // can't have a geo_value without a geo_type, as these are companions
    if (params.has('geography_type')) {
      let geo_type = params.get('geography_type');
      $('select.district-type-select').val(geo_type);
      
      // call the select change function so we get the map layers we need onto the map
      districtTypeSelectChange(false);

      // check for geography value
      // can be absent, in the case of Bay Area, but otherwise will be tied to the parent type selection
      let geo_value;
      if (params.has('geography_value')) {
        geo_value = params.get('geography_value');
        if (geo_value) {
          // hack
          let disabled = false;
          if (geo_type == 'bay-area') {
            geo_type = 'counties';
            disabled = true;        
          }
          // sync the select
          $(`select.location-select[id="${geo_type}"]`)
            .attr('disabled', disabled)
            .show()
            .val(geo_value)
            .trigger('change');
        }
      }
    }
  } else {
    // we got some other params that are not our concern, pretend we'er loading without params
    updateCards();
  }
}

// count goals in the current data set
function updateProjectGoalCount(data=DATA.projects) {
  let objectives = {biodiversity: 0, access: 0, climate: 0};
  data.forEach(function(d) {
    let goals = d['30x30objectives'].split(';');
    if (goals.indexOf('biodiversity') > -1) objectives.biodiversity += 1;
    if (goals.indexOf('access') > -1) objectives.access += 1;
    if (goals.indexOf('climate') > -1) objectives.climate += 1;
  });

  ['biodiversity', 'access', 'climate'].forEach(function(goal) {
    $(`span#${goal}-count`).text(objectives[goal]);
  });
}

// update the dymamic jobs, people, funding values in the form summary message
function updateFormSummaryMessage(data=DATA.projects) {
  let sums = {jobs: 0, served: 0, funding: 0};
  data.forEach(function(d) {
    sums.jobs = sums.jobs+= d['employed_number'];
    sums.served = sums.served+= d['served_number'];
    sums.funding = sums.funding+= d['funding_number'];
  });

  ['funding', 'jobs', 'served'].forEach(function(sum) {
    // Format the value and then update the result
    let value = sums[sum];
    let format = CONFIG.summaries[sum].format;
    value = CONFIG.format[format](value);
    $(`span#${sum}`).text(value);
  });
}

// Construct the modal details and open it
function openModal(project, $opener) {
  // goal "circles" or icons
  let target = $('div.modal div.circle-outer').empty();
  project['30x30objectives'].split(';').forEach(function(goal) {
    $('<span>', {
      class: `circle ${goal}`,
    }).appendTo(target);
  });

  // project name
  $('div.modal .project-title').text(project.projecttitle);

  // organization title
  $('div.modal .project-org').text(project.organization);

  // brief description
  $('div.modal div.project-description').text(project.briefdescription);

  // project link
  if (project.url) {
    $('div.modal div.project-link a').attr('href', project.url).show(); 
  }

  // key activities
  $('div.modal div.key-activities p').text(project.keyactivities);

  // achieve goals/objectives
  $('div.modal div.achieve-goals p').text(project.howobjectives);

  // funding 
  $('div.modal div.funding-demographics #project-funding').text(project.estimatedneed);

  // native territories
  let places = project['native-lands'].split(';');
  let html = places.map(function(place) { return `<span class="modal-place">${place}</span>` });
  $('div.modal div.location #project-territories').html(html);

  // county
  html = project.counties.map(function(place) { return `<span class="modal-place">${place}</span>` });
  $('div.modal div.location #project-counties').html(html);

  // current assembly
  html = project['assembly-current'].map(function(m) { return `<span class="modal-place">AD ${m}</span>`});
  $('div.modal div.location #project-assembly-current').html(html);

  // current senate
  html = project['senate-current'].map(function(m) { return `<span class="modal-place">SD ${m}</span>`});
  $('div.modal div.location #project-senate-current').html(html);

  // future assembly
  html = project['assembly-new'].map(function(m) { return `<span class="modal-place">AD ${m}</span>`});
  $('div.modal div.location #project-assembly-future').html(html);

  // future senate
  html = project['senate-new'].map(function(m) { return `<span class="modal-place">SD ${m}</span>`});
  $('div.modal div.location #project-senate-future').html(html);

  // all set! Open it...
  // see also initModal() where we set some actions based on the position of what opened it
  $('#project-details-modal').data('opener', $opener ? $opener : null);
  CONFIG.modal.show();
}